import React from 'react'
import { useTranslation } from 'react-i18next'
import { CategoryBadge } from './ScoreComparisonCard'

const MS_COLORS = {
  'Extremely Low': 'from-red-500 to-red-600',
  'Low': 'from-orange-400 to-orange-500',
  'Moderate': 'from-yellow-400 to-yellow-500',
  'High': 'from-blue-400 to-blue-500',
  'Extremely High': 'from-green-400 to-green-500',
}

function ScoreCard({ name, msScore, category, ipipConverted, dciTotal }) {
  const { t } = useTranslation('report')
  const gradient = MS_COLORS[category] || 'from-gray-400 to-gray-500'
  return (
    <div className="flex-1 bg-white rounded-xl p-5 shadow-sm border border-gray-100">
      <div className="text-sm font-medium text-gray-500 mb-1">{name}</div>
      <div className={`text-4xl font-bold bg-gradient-to-r ${gradient} bg-clip-text text-transparent`}>
        {msScore}
      </div>
      {/* Plain fallback for PDF capture (hidden on screen, shown via .pdf-capture CSS) */}
      <div className="text-4xl font-bold text-gray-800 hidden pdf-score-fallback">
        {msScore}
      </div>
      <div className="mt-2">
        <CategoryBadge category={category} />
      </div>
      <div className="mt-3 text-xs text-gray-400 space-y-1">
        <div>{t('msScoreSummary.ipipConverted')} <span className="text-gray-600 font-medium">{ipipConverted}</span></div>
        <div>{t('msScoreSummary.dciTotal')} <span className="text-gray-600 font-medium">{dciTotal}</span></div>
      </div>
    </div>
  )
}

export default function MSScoreSummary({ person1, person2, msScores }) {
  const { t } = useTranslation('report')
  return (
    <div className="bg-gradient-to-br from-primary-50 to-white rounded-xl p-6 shadow-sm border border-primary-100">
      <h2 className="text-lg font-bold text-gray-800 mb-1">{t('msScoreSummary.title')}</h2>
      <p className="text-xs text-gray-400 mb-4">
        {t('msScoreSummary.formula')}
      </p>
      <div className="flex gap-4">
        <ScoreCard
          name={person1.respondent.name}
          msScore={msScores.person1.msScore}
          category={msScores.person1.category}
          ipipConverted={person1.ipip.totalConverted}
          dciTotal={person1.dci.total}
        />
        <ScoreCard
          name={person2.respondent.name}
          msScore={msScores.person2.msScore}
          category={msScores.person2.category}
          ipipConverted={person2.ipip.totalConverted}
          dciTotal={person2.dci.total}
        />
      </div>
    </div>
  )
}
